<template>
  <hm-content title="">
    <div>
      <el-button type="text" size="small" @click="refresh">
        刷新审核配置
      </el-button>
    </div>
    <div class="table">
      <el-table
        stripe
        border
        ref="table"
        :data="list"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column
          type="index"
          label="序号"
          header-align="center"
          align="center"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="examineType"
          label="审核类型"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="examineExplain"
          label="说明"
          width="500"
        >
          <template slot-scope="scope">
            {{ scope.row.examineExplain }}
          </template>
        </el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          prop="enabledState"
          label="状态"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.enabledState === 'no'">
              未启用
            </div>
            <div v-else-if="scope.row.enabledState === 'yes'">
              已启用
            </div>
            <div v-else-if="scope.row.enabledState === 'notConfigured'">
              未配置
            </div>
          </template>
        </el-table-column>

        <el-table-column label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <div class="flex flex-center item-center">
              <el-button
                type="text"
                size="small"
                class="blue"
                v-if="scope.row.enabledState === 'notConfigured'"
                @click="setting(scope.row, 'setting')"
              >
                配置
              </el-button>
              <el-button
                type="text"
                size="small"
                class="blue"
                v-if="scope.row.enabledState !== 'notConfigured'"
                @click="setting(scope.row, 'edit')"
              >
                {{ scope.row.enabledState === "yes" ? "查看" : "修改" }}
              </el-button>

              <el-divider direction="vertical"></el-divider>
              <el-button
                type="text"
                size="small"
                class="blue"
                @click="enabledState(scope.row, 'yes')"
                v-if="scope.row.enabledState === 'no'"
              >
                启动
              </el-button>
              <el-button
                type="text"
                size="small"
                class="blue"
                @click="enabledState(scope.row, 'no')"
                v-else-if="scope.row.enabledState === 'yes'"
              >
                停用
              </el-button>
              <el-button
                type="text"
                size="small"
                v-else
                class="gray"
                style="width:26px"
              >
                -- --
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- <div class="hm-pagination">
      <el-pagination
        background
        :total="total"
        @current-change="paging"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="currentPage"
      ></el-pagination>
    </div> -->
    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      width="1000px"
      :visible.sync="dialogVisible"
    >
      <el-dialog
        width="1000px"
        :close-on-click-modal="false"
        :title="innerTitle"
        :visible.sync="innerVisible"
        append-to-body
      >
        <el-form
          :model="detailsRuleForm"
          :rules="detailsRules"
          ref="detailsRuleForm"
          label-width="100px"
          class="large-label-form"
        >
          <el-form-item label="审核步骤名称" prop="stepName">
            <el-input
              clearable
              v-model.trim="detailsRuleForm.stepName"
              maxlength="20"
              size="small"
              style="width: 200px"
              :disabled="row.enabledState === 'yes'"
              placeholder="请输入审核步骤名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="审核方式" prop="examineMode">
            <el-radio-group
              v-model="detailsRuleForm.examineMode"
              :disabled="row.enabledState === 'yes'"
            >
              <el-radio label="andSign">会签（须所有审核人通过） </el-radio>
              <el-radio label="orSign"
                >或签（一名审核人通过或驳回即可）
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="审核人员授权" prop="allEmpList">
            <div class="mb10" v-if="row.enabledState !== 'yes'">
              <el-button
                type="primary"
                size="small"
                @click="dialogVisibleEmp = true"
              >
                添加
              </el-button>
            </div>

            <div v-if="detailsRuleForm.allEmpList.length">
              <el-table
                stripe
                border
                ref="table"
                :data="detailsRuleForm.allEmpList"
                style="width: 100%"
                id="table"
                size="small"
                max-height="440"
              >
                <el-table-column
                  type="index"
                  label="序号"
                  header-align="center"
                  align="center"
                ></el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  label="部门"
                  show-overflow-tooltip
                  prop="departName"
                  column-key="departName"
                ></el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  label="账号"
                  show-overflow-tooltip
                  prop="username"
                  column-key="username"
                ></el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  label="姓名"
                  prop="realname"
                  column-key="realname"
                ></el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  label="工号"
                  prop="workNum"
                  column-key="workNum"
                ></el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  label="操作"
                  v-if="row.enabledState !== 'yes'"
                >
                  <template slot-scope="scope">
                    <el-button
                      type="text"
                      size="small"
                      @click="del(scope.$index)"
                    >
                      删除
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-form-item>
        </el-form>

        <div slot="footer" class="dialog-footer flex flex-center mt20">
          <el-button
            type="primary"
            size="small"
            @click="save('detailsRuleForm')"
            v-if="row.enabledState !== 'yes'"
          >
            保存</el-button
          >
          <el-button type="info" size="small" @click="innerVisible = false">
            取消</el-button
          >
        </div>
      </el-dialog>
      <div class="mb10" v-if="row.enabledState !== 'yes'">
        <el-button type="primary" size="small" @click="add">
          添加审核步骤
        </el-button>
        <span class="form-red">最多可添加5个审核步骤</span>
      </div>
      <div>
        <el-table
          stripe
          border
          ref="table"
          :data="reviewList"
          style="width: 100%"
          id="table"
          size="small"
        >
          <el-table-column
            type="index"
            label="审核顺序"
            header-align="center"
            align="center"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="stepName"
            label="审核步骤名称"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="payAgentName"
            label="审核方式"
          >
            <template slot-scope="scope">
              {{
                scope.row.examineMode === "andSign"
                  ? "会签（须所有审核人通过）"
                  : "或签（一名审核人通过或驳回即可）"
              }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="createTime"
            label="添加时间"
          >
          </el-table-column>
          <el-table-column label="操作" header-align="center" align="center">
            <template slot-scope="scope">
              <div class="flex flex-center item-center">
                <el-button type="text" size="small" @click="edit(scope.row)">
                  {{ row.enabledState !== "yes" ? "修改" : "查看" }}
                </el-button>
                <template v-if="row.enabledState !== 'yes'">
                  <el-divider direction="vertical"></el-divider>
                  <el-button
                    type="text"
                    size="small"
                    v-if="scope.$index !== 0"
                    @click.stop="sortUp(scope.$index, scope.row)"
                  >
                    上移
                  </el-button>
                  <el-button type="text" size="small" v-else class="gray">
                    -- --
                  </el-button>
                  <el-divider direction="vertical"></el-divider>
                  <el-button
                    type="text"
                    size="small"
                    @click.stop="sortDown(scope.$index, scope.row)"
                  >
                    下移
                  </el-button>
                  <el-divider direction="vertical"></el-divider>
                  <el-button
                    type="text"
                    size="small"
                    class="danger"
                    @click="remove(scope.row)"
                  >
                    删除
                  </el-button>
                </template>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer flex flex-center mt20">
        <!-- <el-button type="primary" size="small" @click="confirm">
          确认</el-button
        > -->
        <el-button type="info" size="small" @click="dialogVisible = false">
          取消</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      title="提示"
      width="800px"
      :visible.sync="dialogVisibleErr"
    >
      <div class="text-center danger">
        该配置有正在审核中的任务，如果停用，审核中的任务将全部被驳回，是否确认停用
      </div>
      <div slot="footer" class="dialog-footer flex flex-center mt20">
        <el-button type="primary" size="small" @click="confirm">
          确认</el-button
        >
        <el-button type="info" size="small" @click="dialogVisibleErr = false">
          取消</el-button
        >
      </div>
    </el-dialog>
    <hm-filter-employee
      selectType="multiple"
      v-if="dialogVisibleEmp"
      @setMultipleEmpInfo="setMultipleEmpInfo"
      :visible="dialogVisibleEmp"
      @close="dialogVisibleEmp = false"
    ></hm-filter-employee>
  </hm-content>
</template>

<script>
import HmFilterEmployee from "@/components/HmFilterEmployee";
import { arrayUnique2 } from "@/utils/utils";
import Sortable from "sortablejs";
export default {
  components: { HmFilterEmployee },
  data() {
    return {
      dialogVisibleErr: false,
      innerRow: {},
      innerType: "",
      innerTitle: "添加审核步骤",
      row: {},
      dialogVisibleEmp: false,
      detailsRuleForm: {
        stepName: "",
        examineMode: "andSign",
        personType: "employee",
        allEmpList: []
      },
      detailsRules: {
        stepName: [
          {
            required: true,
            message: "请输入审核步骤名称！",
            trigger: "blur"
          }
        ],
        examineMode: {
          required: true,
          message: "请选择审核方式！",
          trigger: "blur"
        },
        allEmpList: {
          required: true,
          message: "请授权人员！"
        }
      },
      innerVisible: false,
      reviewList: [],
      dialogVisible: false,
      title: "",
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      searchCondition: {},
      isEditState: false
    };
  },
  created() {},
  mounted() {
    this.queryList();
  },
  methods: {
    async queryWaitExamineList() {
      const { result } = await this.$store.dispatch("queryWaitExamineList", {
        id: this.row.id
      });
      this.isEditState = result;
      console.log("result: ", result);
    },
    async queryExamineConfigStepInfo() {
      const { result } = await this.$store.dispatch(
        "queryExamineConfigStepInfo",
        {
          id: this.innerRow.id
        }
      );
      for (let key in result) {
        if (this.detailsRuleForm.hasOwnProperty(key)) {
          this.detailsRuleForm[key] = result[key];
        }
      }
      this.detailsRuleForm.allEmpList = result.personList;
    },
    async enabledState(row, enabledState) {
      this.row = row;

      await this.queryWaitExamineList();

      if (!this.isEditState) {
        await this.$store.dispatch("updateEnabledState", {
          id: row.id,
          enabledState
        });
        this.$message({
          message: "操作成功！",
          type: "success"
        });
        this.queryList();
      } else {
        this.dialogVisibleErr = true;
      }
    },
    edit(row) {
      this.innerRow = row;
      this.queryExamineConfigStepInfo();
      this.innerVisible = true;
      this.innerTitle = "修改审核步骤";
      this.innerType = "edit";
    },
    save(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this[formName]));
          params.personIds = this.detailsRuleForm.allEmpList.map(
            v => v.employeeId
          );
          params.examId = this.row.id;
          if (this.innerType === "edit") {
            params.id = this.innerRow.id;
          }
          let name =
            this.innerType === "edit"
              ? "updateExamineConfigStepInfo"
              : "saveExamineConfigStepInfo";
          this.$store.dispatch(name, params).then(res => {
            if (res.code == "0") {
              this.innerVisible = false;
              this.$message({
                message: " 操作成功",
                type: "success"
              });
              this.detailsRuleForm = {
                stepName: "",
                examineMode: "andSign",
                personType: "employee",
                allEmpList: []
              };
              this.resetForm();

              this.queryExamineConfigStepInfoList();
              this.queryList();
            }
          });
        }
      });
    },
    resetForm() {
      setTimeout(() => {
        if (this.$refs.detailsRuleForm) {
          this.$refs.detailsRuleForm.resetFields();
        }
      }, 200);
    },
    del(i) {
      this.detailsRuleForm.allEmpList.splice(i, 1);
    },
    setMultipleEmpInfo(info) {
      console.log("info: ", info);
      this.detailsRuleForm.allEmpList.push(...info);
      this.detailsRuleForm.allEmpList = arrayUnique2(
        this.detailsRuleForm.allEmpList,
        "employeeId"
      );
      this.dialogVisibleEmp = false;
    },
    add() {
      this.innerVisible = true;
      this.innerTitle = "添加审核步骤";
      this.innerType = "add";
      this.resetForm();
    },
    async operateExamineConfigStepInfo(row, operateType) {
      let params = JSON.parse(JSON.stringify(row));
      params.operateType = operateType;
      await this.$store.dispatch("operateExamineConfigStepInfo", params);
      this.queryExamineConfigStepInfoList();
    },
    // 上移按钮
    sortUp(index, row) {
      if (index === 0) {
        this.$message({
          message: "已经是列表中第一个素材！",
          type: "warning"
        });
      } else {
        this.operateExamineConfigStepInfo(row, "up");
        // let temp = this.reviewList[index - 1];
        // this.$set(this.reviewList, index - 1, this.reviewList[index]);
        // this.$set(this.reviewList, index, temp);
      }
    },
    remove(row) {
      this.$confirm("删除本行数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.operateExamineConfigStepInfo(row, "del");
      });
    },
    // 下移按钮
    sortDown(index, row) {
      if (index === this.reviewList.length - 1) {
        this.$message({
          message: "已经是列表中最后一个素材！",
          type: "warning"
        });
      } else {
        this.operateExamineConfigStepInfo(row, "down");
        // let i = this.reviewList[index + 1];
        // this.$set(this.reviewList, index + 1, this.reviewList[index]);
        // this.$set(this.reviewList, index, i);
      }
    },
    async setting(row, type) {
      this.row = row;
      if (type === "setting") {
        this.title = "配置";
      } else if (type === "edit") {
        this.title = "修改";
      }
      this.queryExamineConfigStepInfoList();
      this.dialogVisible = true;
    },
    async queryExamineConfigStepInfoList() {
      const { result } = await this.$store.dispatch(
        "queryExamineConfigStepInfoList",
        {
          id: this.row.id
        }
      );
      this.reviewList = result;
    },
    async refresh() {
      const { result } = await this.$store.dispatch(
        "initializeStoreExamineConfig"
      );
      if (result === "success") {
        await this.queryList();
      }
    },
    rowDrop() {
      const tbody = document.querySelector(".el-table__body-wrapper tbody");
      const _this = this;
      Sortable.create(tbody, {
        onEnd({ newIndex, oldIndex }) {
          const currRow = _this.reviewList.splice(oldIndex, 1)[0];
          _this.reviewList.splice(newIndex, 0, currRow);
        }
      });
    },
    async confirm() {
      await this.$store.dispatch("updateEnabledState", {
        id: this.row.id,
        enabledState: "no"
      });
      this.$message({
        message: "操作成功！",
        type: "success"
      });
      this.dialogVisibleErr = false;
      this.queryList();
    },
    async queryList() {
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch(
        "queryExamineConfigList",
        params
      );
      if (code === "0") {
        // const { total, records } = result;
        this.list = result;
        this.total = result.length;
      }
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    }
  }
};
</script>

<style scoped lang="scss"></style>
